import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.89 13.93H4.11a2 2 0 0 1-2.05-2V4.11a2.05 2.05 0 0 1 2.05-2.05H6.7a2.05 2.05 0 0 1 2.05 2.05v.54h3.14a2.05 2.05 0 0 1 2 2.05v5.19a2 2 0 0 1-2 2.04Zm-3.14-1.5h3.14a.55.55 0 0 0 .55-.54V6.7a.55.55 0 0 0-.55-.55H8.75ZM4.11 3.56a.55.55 0 0 0-.55.55v7.78a.55.55 0 0 0 .55.54h3.14V4.11a.55.55 0 0 0-.55-.55ZM11.24 10H10v1.3h1.29Zm0-2.69H10V8.6h1.29ZM6.05 10H4.76v1.3h1.29Zm0-2.69H4.76V8.6h1.29Zm0-2.68H4.76v1.3h1.29Z';
const draw24px =
  'M18,20.75H6A2.75,2.75,0,0,1,3.25,18V6A2.75,2.75,0,0,1,6,3.25h4A2.75,2.75,0,0,1,12.75,6V7.25H18A2.75,2.75,0,0,1,20.75,10v8A2.75,2.75,0,0,1,18,20.75Zm-5.25-1.5H18A1.25,1.25,0,0,0,19.25,18V10A1.25,1.25,0,0,0,18,8.75H12.75ZM6,4.75A1.25,1.25,0,0,0,4.75,6V18A1.25,1.25,0,0,0,6,19.25h5.25V6A1.25,1.25,0,0,0,10,4.75ZM17,15.08H15v2h2Zm0-4.16H15v2h2ZM9,15.08H7v2H9Zm0-4.16H7v2H9ZM9,6.79H7v2H9Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingsIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'buildings'),
) as IconWithRender;

BuildingsIcon.displayName = 'BuildingsIcon';
BuildingsIcon.propTypes = Icon.propTypes;
BuildingsIcon.renderIcon = (props) => <BuildingsIcon {...props} />;
export default BuildingsIcon;
